// import React, { useState, useEffect, useCallback } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import { ArrowLeft, Info, Save, Loader2, CheckCircle, AlertCircle } from "lucide-react";
// import api from "./axiosConfig"; // Import your configured axios instance

// const LeadFinderEdit = () => {
//   // --- State ---
//   const [keywords, setKeywords] = useState(""); // Initialize empty
//   const [negativeKeywords, setNegativeKeywords] = useState(""); // Initialize empty
//   // Add state for other config fields if you want to edit them here (e.g., is_active)
//   // const [isActive, setIsActive] = useState(true);

//   const [isLoading, setIsLoading] = useState(true); // Loading initial settings
//   const [isSaving, setIsSaving] = useState(false); // Saving state
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");

//   const navigate = useNavigate(); // If using react-router for navigation

//   // --- Fetch Initial Settings ---
//   const fetchSettings = useCallback(async () => {
//     setIsLoading(true);
//     setError(null); // Clear previous errors on fetch attempt
//     try {
//       // Use the correct API endpoint matching your urls.py setup
//       const response = await api.get("api/leadfinder/config/");
//       if (response.data) {
//         // Populate state with fetched data
//         setKeywords(response.data.keywords || "");
//         setNegativeKeywords(response.data.negative_keywords || "");
//         // setIsActive(response.data.is_active ?? true); // Example for another field
//       }
//     } catch (err) {
//       console.error("Error fetching Lead Finder settings:", err);
//       // Handle specific errors, e.g., 401 handled by interceptor, 404 maybe means no config yet?
//       if (err.response?.status === 404) {
//         setError("Could not find configuration. Please save your settings.");
//       } else {
//         setError("Failed to load your current settings. Please try again later.");
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   }, []); // No dependencies needed if it only runs once on mount

//   useEffect(() => {
//     fetchSettings();
//   }, [fetchSettings]); // fetchSettings is stable due to useCallback

//   // --- Save Settings Handler ---
//   const handleSaveSettings = async (event) => {
//     event.preventDefault();
//     setIsSaving(true);
//     setError(null);
//     setSuccessMessage("");

//     // Prepare data payload - only send fields being updated
//     const settingsData = {
//       keywords: keywords,
//       negative_keywords: negativeKeywords,
//       // is_active: isActive, // Include other fields if they are editable here
//     };

//     try {
//       // Use the correct API endpoint and PUT method
//       const response = await api.put("api/leadfinder/config/", settingsData);

//       if (response.status === 200 && response.data) {
//         setSuccessMessage("Settings saved successfully!");
//         // Optionally update state again from response if needed, though PUT often returns updated object
//         setKeywords(response.data.keywords || "");
//         setNegativeKeywords(response.data.negative_keywords || "");
//         // setIsActive(response.data.is_active ?? true);

//         setTimeout(() => setSuccessMessage(""), 3000); // Clear message
//       } else {
//         // Handle non-200 success responses if necessary
//         throw new Error("Failed to save settings with status: " + response.status);
//       }
//     } catch (err) {
//       console.error("Error saving Lead Finder settings:", err);
//       // Extract more specific error from response if available
//       const message = err.response?.data?.error || err.message || "Failed to save settings. Please check your input and try again.";
//       setError(message);
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // --- Render Logic ---

//   // Show loading indicator while fetching initial settings
//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center min-h-[300px]">
//         <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-3xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
//       <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//         {/* Back Navigation */}
//         {/* Use onClick={() => navigate(-1)} or specific path */}
//         <button
//           onClick={() => navigate("/leadfinder")}
//           className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-6 group"
//         >
//           <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform" />
//           Back to Lead Feed
//         </button>

//         {/* Header */}
//         <h1 className="text-3xl font-bold text-gray-900 mb-2">Configure Your AI Lead Finder</h1>
//         <p className="text-gray-600 mb-8">
//           Tell the AI what problems your product solves so it can find people actively discussing related needs online. More specific
//           keywords yield better results.
//         </p>

//         {/* Display initial fetch error if occurred */}
//         {error && !isSaving && (
//           <div className="mb-4 text-sm text-red-600 bg-red-50 p-3 rounded-md border border-red-200 flex items-center">
//             <AlertCircle size={16} className="mr-2 flex-shrink-0" /> {error}
//           </div>
//         )}

//         {/* Settings Form */}
//         <form onSubmit={handleSaveSettings} className="bg-white p-6 sm:p-8 rounded-xl shadow-lg border border-gray-200 space-y-6">
//           {/* Problem Keywords Section */}
//           <div>
//             <label htmlFor="keywords" className="block text-sm font-medium text-gray-800 mb-1.5">
//               Keywords/Phrases Your Solution Addresses <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               id="keywords"
//               rows={4}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-300 focus:border-emerald-500 transition duration-150 ease-in-out shadow-sm text-gray-800 placeholder-gray-400"
//               placeholder="e.g., social media scheduling tool, automate Instagram posts..."
//               value={keywords}
//               onChange={(e) => setKeywords(e.target.value)}
//               required
//               aria-describedby="keywords-help"
//             />
//             <p id="keywords-help" className="mt-1.5 text-xs text-gray-500">
//               Enter comma-separated terms people use when describing problems you solve or solutions like yours. Required.
//             </p>
//           </div>

//           {/* Negative Keywords Section */}
//           <div>
//             <label htmlFor="negativeKeywords" className="block text-sm font-medium text-gray-800 mb-1.5">
//               Negative Keywords (Optional)
//             </label>
//             <input
//               type="text"
//               id="negativeKeywords"
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-300 focus:border-emerald-500 transition duration-150 ease-in-out shadow-sm text-gray-800 placeholder-gray-400"
//               placeholder="e.g., free, hiring, job, discount code, cheap"
//               value={negativeKeywords}
//               onChange={(e) => setNegativeKeywords(e.target.value)}
//               aria-describedby="negative-keywords-help"
//             />
//             <p id="negative-keywords-help" className="mt-1.5 text-xs text-gray-500">
//               Enter comma-separated terms to exclude from results (e.g., 'free', 'job').
//             </p>
//           </div>

//           {/* Add is_active toggle here if needed */}
//           {/* Example:
//           <div className="flex items-center">
//              <label htmlFor="is_active" className="flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   id="is_active"
//                   className="rounded h-4 w-4 text-emerald-600 border-gray-300 focus:ring-emerald-500"
//                   checked={isActive}
//                   onChange={(e) => setIsActive(e.target.checked)}
//                 />
//                 <span className="ml-2 text-sm text-gray-700">Activate AI Lead Scanning</span>
//              </label>
//           </div>
//           */}

//           {/* Credit Usage Info */}
//           <div className="bg-emerald-50/60 border border-emerald-100 rounded-lg p-4 flex items-start space-x-3">
//             <Info size={18} className="text-emerald-500 flex-shrink-0 mt-0.5" />
//             <p className="text-xs text-emerald-800">
//               The AI Lead Finder runs automatically based on these settings.
//               {/* Using actions on discovered leads (like 'Save Lead' or
//               'Generate Outreach') consumes your Lead Credits. */}
//             </p>
//           </div>

//           {/* Error and Success Messages for Saving */}
//           {error &&
//             isSaving && ( // Show saving error only during/after save attempt
//               <div className="text-sm text-red-600 bg-red-50 p-3 rounded-md border border-red-200 flex items-center">
//                 <AlertCircle size={16} className="mr-2 flex-shrink-0" /> {error}
//               </div>
//             )}
//           {successMessage && (
//             <div className="text-sm text-green-600 bg-green-50 p-3 rounded-md border border-green-200 flex items-center">
//               <CheckCircle size={16} className="mr-2 flex-shrink-0" /> {successMessage}
//             </div>
//           )}

//           {/* Save Button */}
//           <button
//             type="submit"
//             disabled={isSaving} // Disable only while saving
//             className="w-full flex items-center justify-center bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white text-base font-semibold py-3 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-all duration-300 shadow-md hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
//           >
//             {isSaving ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Save className="w-5 h-5 mr-2" />}
//             {isSaving ? "Saving Settings..." : "Save Settings & Activate Scan"}
//           </button>
//         </form>
//       </motion.div>
//     </div>
//   );
// };

// export default LeadFinderEdit;

// src/LeadFinderSetup.jsx

// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { ArrowLeft, Info, Save, Loader2, CheckCircle, AlertCircle, X as IconX } from "lucide-react"; // Renamed X to avoid conflict
// import api from "./axiosConfig"; // Your configured axios instance

// const LeadFinderSetup = () => {
//   // --- State ---
//   const [keywords, setKeywords] = useState("");
//   const [negativeKeywords, setNegativeKeywords] = useState("");
//   const [isActive, setIsActive] = useState(true);

//   const [isLoading, setIsLoading] = useState(true);
//   const [isSaving, setIsSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");

//   const navigate = useNavigate();

//   // --- Fetch Initial Settings ---
//   const fetchSettings = useCallback(async () => {
//     console.log("Attempting to fetch Lead Finder settings...");
//     setIsLoading(true);
//     setError(null);
//     try {
//       const response = await api.get("/api/leadfinder/config/");
//       console.log("Settings fetched:", response.data);
//       if (response.data) {
//         setKeywords(response.data.keywords || "");
//         setNegativeKeywords(response.data.negative_keywords || "");
//         setIsActive(response.data.is_active ?? true);
//       }
//     } catch (err) {
//       console.error("Error fetching Lead Finder settings:", err);
//       if (err.response?.status !== 401) {
//         const message = err.response?.data?.error || err.message || "Failed to load current settings.";
//         if (err.response?.status === 404) {
//           setError("No configuration found. Please enter and save your settings.");
//         } else {
//           setError(message);
//         }
//       }
//       setKeywords("");
//       setNegativeKeywords("");
//       setIsActive(true); // Reset on error
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchSettings();
//   }, [fetchSettings]);

//   // --- Save Settings Handler ---
//   const handleSaveSettings = async (event) => {
//     event.preventDefault();
//     setIsSaving(true);
//     setError(null);
//     setSuccessMessage("");
//     const settingsData = { keywords, negative_keywords: negativeKeywords, is_active: isActive };
//     console.log("Attempting to save settings:", settingsData);
//     try {
//       const response = await api.put("/api/leadfinder/config/", settingsData);
//       if (response.status === 200 && response.data) {
//         console.log("Settings saved successfully:", response.data);
//         setSuccessMessage("Settings saved successfully!");
//         setKeywords(response.data.keywords || "");
//         setNegativeKeywords(response.data.negative_keywords || "");
//         setIsActive(response.data.is_active ?? true);
//         setTimeout(() => setSuccessMessage(""), 3000);
//       } else {
//         throw new Error(`Save failed (Status: ${response.status})`);
//       }
//     } catch (err) {
//       console.error("Error saving Lead Finder settings:", err);
//       const message = err.response?.data?.error || err.response?.data?.detail || err.message || "An unknown error occurred.";
//       setError(message);
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // --- Render Logic ---
//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center min-h-[400px] p-4">
//         <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
//         <span className="ml-3 text-gray-500">Loading Configuration...</span>
//       </div>
//     );
//   }

//   return (
//     // Page Container
//     <div className="max-w-3xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
//       <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
//         {/* Back Navigation */}
//         <button
//           onClick={() => navigate(-1)}
//           className="inline-flex items-center text-sm text-gray-500 hover:text-emerald-700 mb-6 group transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 rounded"
//         >
//           <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform" />
//           Back
//         </button>

//         {/* Header */}
//         <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Configure Your AI Lead Finder</h1>
//         <p className="text-sm sm:text-base text-gray-600 mb-8">
//           Provide keywords related to problems your product solves. Our AI will scan social platforms daily for relevant conversations.
//         </p>

//         {/* --- Alerts --- */}
//         <AnimatePresence>
//           {error && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               // Alert Base Styles
//               className="mb-4 text-sm p-4 rounded-lg border flex items-center gap-2 shadow-sm overflow-hidden
//                                text-red-700 bg-red-100 border-red-300" // Error specific colors
//             >
//               <AlertCircle size={18} className="flex-shrink-0" />
//               <span>{error}</span>
//               <button onClick={() => setError(null)} className="ml-auto text-red-600 hover:text-red-800 focus:outline-none">
//                 <IconX size={18} />
//               </button>
//             </motion.div>
//           )}
//         </AnimatePresence>
//         <AnimatePresence>
//           {successMessage && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               // Alert Base Styles
//               className="mb-4 text-sm p-4 rounded-lg border flex items-center gap-2 shadow-sm overflow-hidden
//                                text-green-700 bg-green-100 border-green-300" // Success specific colors
//             >
//               <CheckCircle size={18} className="flex-shrink-0" />
//               <span>{successMessage}</span>
//             </motion.div>
//           )}
//         </AnimatePresence>
//         {/* --- End Alerts --- */}

//         {/* Settings Form Card */}
//         <form onSubmit={handleSaveSettings} className="bg-white p-6 sm:p-8 rounded-xl shadow-lg border border-gray-200 space-y-6">
//           {/* Keywords Input Section */}
//           <div className="space-y-1.5">
//             <label htmlFor="keywords" className="block text-sm font-medium text-gray-700">
//               Keywords/Phrases to Find <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               id="keywords"
//               rows={5} // Slightly larger area
//               className="block w-full px-4 py-2 border border-gray-300 rounded-lg text-sm sm:text-base text-gray-900 placeholder-gray-400 shadow-sm transition duration-150 ease-in-out focus:ring-2 focus:ring-emerald-400 focus:border-emerald-500 focus:outline-none"
//               placeholder="e.g., social media scheduling tool, automate Instagram posts, need better project management for remote teams, alternative to Hootsuite..."
//               value={keywords}
//               onChange={(e) => setKeywords(e.target.value)}
//               required
//               aria-required="true"
//               aria-describedby="keywords-help"
//             />
//             <p id="keywords-help" className="text-xs text-gray-500">
//               Enter comma-separated terms people use when expressing problems or seeking solutions like yours. Required.
//             </p>
//           </div>

//           {/* Negative Keywords Input Section */}
//           <div className="space-y-1.5">
//             <label htmlFor="negativeKeywords" className="block text-sm font-medium text-gray-700">
//               Negative Keywords (Optional)
//             </label>
//             <input
//               type="text"
//               id="negativeKeywords"
//               className="block w-full px-4 py-2 border border-gray-300 rounded-lg text-sm sm:text-base text-gray-900 placeholder-gray-400 shadow-sm transition duration-150 ease-in-out focus:ring-2 focus:ring-emerald-400 focus:border-emerald-500 focus:outline-none"
//               placeholder="e.g., free, hiring, job, discount, cheap, template, example, tutorial"
//               value={negativeKeywords}
//               onChange={(e) => setNegativeKeywords(e.target.value)}
//               aria-describedby="negative-keywords-help"
//             />
//             <p id="negative-keywords-help" className="mt-1.5 text-xs text-gray-500">
//               Comma-separated terms to exclude irrelevant results (e.g., 'free', 'job').
//             </p>
//           </div>

//           {/* Is Active Toggle Section */}
//           <div className="flex items-center pt-2">
//             <label htmlFor="is_active_toggle" className="flex items-center cursor-pointer group">
//               {/* Simple Checkbox - Can replace with a styled toggle component library if desired */}
//               <input
//                 type="checkbox"
//                 id="is_active_toggle"
//                 className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
//                 checked={isActive}
//                 onChange={(e) => setIsActive(e.target.checked)}
//               />
//               <span className="ml-3 text-sm text-gray-800 font-medium group-hover:text-emerald-700 transition-colors">
//                 Activate AI Lead Scanning
//               </span>
//             </label>
//             <span className="ml-4 text-xs text-gray-400 hidden sm:inline">(Enable this to allow automated background scans)</span>
//           </div>

//           {/* Credit Usage Info Section */}
//           <div className="bg-emerald-50/70 border border-emerald-200/80 rounded-lg p-4 flex items-start space-x-3">
//             <Info size={20} className="text-emerald-600 flex-shrink-0 mt-0.5" />
//             <div>
//               <h4 className="text-sm font-medium text-emerald-900 mb-1">How Lead Finder Works</h4>
//               <p className="text-xs text-emerald-800">
//                 If activated, our AI scans sources like Reddit & Twitter daily based on your keywords. Actions you take on discovered leads
//                 (like 'Save Lead') consume Lead Credits from your plan allowance. You can view discovered leads on the main Lead Finder
//                 page.
//               </p>
//             </div>
//           </div>

//           {/* Save Button Section */}
//           <div className="pt-4 border-t border-gray-100 flex justify-end">
//             <motion.button
//               whileHover={{ scale: 1.02 }}
//               whileTap={{ scale: 0.98 }}
//               type="submit"
//               disabled={isSaving}
//               // Apply primary button styles directly
//               className="inline-flex items-center justify-center bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 active:from-emerald-700 active:to-emerald-800 text-white text-sm sm:text-base font-semibold py-2.5 px-5 sm:px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-all duration-300 shadow hover:shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
//             >
//               {isSaving ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Save className="w-5 h-5 mr-2" />}
//               {isSaving ? "Saving..." : "Save Configuration"}
//             </motion.button>
//           </div>
//         </form>
//       </motion.div>
//     </div>
//   );
// };

// export default LeadFinderSetup;

// src/LeadFinderSetup.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, Info, Save, Loader2, CheckCircle, AlertCircle, X as IconX, Lightbulb } from "lucide-react";
import api from "./axiosConfig";

const LeadFinderSetup = () => {
  // --- State ---
  const [initialKeywords, setInitialKeywords] = useState(""); // For user's first input
  const [suggestedKeywords, setSuggestedKeywords] = useState([]); // From LLM
  const [selectedKeywords, setSelectedKeywords] = useState([]); // Final list user chose
  const [negativeKeywords, setNegativeKeywords] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [isLoading, setIsLoading] = useState(true); // Loading initial config
  const [isSuggesting, setIsSuggesting] = useState(false); // Loading suggestions
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [fetchError, setFetchError] = useState(null); // Separate error for initial fetch
  const [suggestionError, setSuggestionError] = useState(null); // Error during suggestion
  const [saveError, setSaveError] = useState(null); // Error during save
  const [successMessage, setSuccessMessage] = useState("");

  const [planName, setPlanName] = useState("Free");
  const [keywordLimit, setKeywordLimit] = useState(3); // Default limit

  const navigate = useNavigate();

  // --- Fetch Initial Settings (Keywords are now list) ---
  const fetchSettings = useCallback(async () => {
    console.log("Attempting to fetch Lead Finder settings...");
    setIsLoading(true);
    setFetchError(null);
    try {
      const response = await api.get("/api/leadfinder/config/");
      if (response.data) {
        // Set selected keywords from saved config (which is now a list)
        setSelectedKeywords(response.data.keywords || []);
        // We don't store initial keywords, maybe prefill negative?
        setNegativeKeywords(response.data.negative_keywords || "");
        setIsActive(response.data.is_active ?? true);
        setPlanName(response.data.plan_name || "Free");
        setKeywordLimit(response.data.keyword_limit || 3);
        // Clear initial keywords field if config loaded
        setInitialKeywords("");
      }
    } catch (err) {
      /* ... Error handling ... */
    } finally {
      setIsLoading(false);
    }
  }, []); // Removed dependency on potentially changing state

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  // --- Get Keyword Suggestions Handler ---
  const handleSuggestKeywords = async () => {
    if (!initialKeywords.trim()) {
      setSuggestionError("Please enter at least one initial keyword or concept.");
      return;
    }
    setIsSuggesting(true);
    setError(null);
    setSuggestionError(null);
    setSuccessMessage("");
    try {
      const response = await api.post("/api/leadfinder/suggest-keywords/", {
        initial_keywords: initialKeywords,
        // product_context: "" // Optionally get product description from somewhere
      });
      if (response.data && Array.isArray(response.data.suggested_keywords)) {
        setSuggestedKeywords(response.data.suggested_keywords);
        // Maybe auto-select initial keywords if they appear in suggestions?
      } else {
        setSuggestionError("Received unexpected data from suggestions API.");
      }
    } catch (err) {
      console.error("Error getting keyword suggestions:", err);
      const message = err.response?.data?.error || "Failed to get keyword suggestions.";
      setSuggestionError(message);
    } finally {
      setIsSuggesting(false);
    }
  };

  // --- Handle Selection Change ---
  const handleKeywordSelection = (keyword) => {
    setSelectedKeywords((prevSelected) => {
      const newSet = new Set(prevSelected);
      if (newSet.has(keyword)) {
        newSet.delete(keyword); // Deselect
      } else {
        if (newSet.size < keywordLimit) {
          newSet.add(keyword); // Select if limit not reached
        } else {
          // Optional: Show feedback that limit is reached
          setError(`You can only select up to ${keywordLimit} keywords on the ${planName} plan.`);
          setTimeout(() => setError(null), 3000);
        }
      }
      return Array.from(newSet); // Convert back to array for state
    });
  };

  // --- Save Final Configuration Handler ---
  const handleSaveSettings = async (event) => {
    event.preventDefault();
    if (selectedKeywords.length === 0) {
      setError("Please select at least one keyword to track.");
      return;
    }
    if (selectedKeywords.length > keywordLimit) {
      setError(`Cannot save more than ${keywordLimit} keywords for your plan.`);
      return;
    }

    setIsSaving(true);
    setError(null);
    setSaveError(null);
    setSuccessMessage("");
    const settingsData = {
      keywords: selectedKeywords, // Send the selected list
      negative_keywords: negativeKeywords,
      is_active: isActive,
    };
    console.log("Attempting to save final settings:", settingsData);
    try {
      const response = await api.put("/api/leadfinder/config/", settingsData);
      if (response.status === 200 && response.data) {
        setSuccessMessage("Configuration saved successfully!");
        setSelectedKeywords(response.data.keywords || []); // Update state from response
        setNegativeKeywords(response.data.negative_keywords || "");
        setIsActive(response.data.is_active ?? true);
        setTimeout(() => setSuccessMessage(""), 3000);
        // Maybe navigate away after save? navigate('/leadfinder');
      } else {
        throw new Error(`Save failed`);
      }
    } catch (err) {
      console.error("Error saving Lead Finder settings:", err);
      const message = err.response?.data?.error || err.response?.data?.detail || err.message || "Failed to save.";
      setSaveError(message); // Use separate error state for save errors
      setError(message); // Also set general error for display
    } finally {
      setIsSaving(false);
    }
  };

  // --- Render Logic ---
  if (isLoading) {
    /* ... Loading UI ... */
  }

  return (
    <div className="max-w-3xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center text-sm text-gray-500 hover:text-emerald-700 mb-6 group transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 rounded"
        >
          <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform" /> Back
        </button>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Configure Your AI Lead Finder</h1>
        <p className="text-sm sm:text-base text-gray-600 mb-8">
          {" "}
          Define keywords related to problems your product solves to find relevant online conversations.
        </p>

        {/* Display Errors */}
        <AnimatePresence>
          {" "}
          {fetchError && !isSaving && <motion.div className="alert-base error-alert mb-4">...</motion.div>}{" "}
        </AnimatePresence>
        <AnimatePresence> {suggestionError && <motion.div className="alert-base error-alert mb-4">...</motion.div>} </AnimatePresence>
        <AnimatePresence> {saveError && <motion.div className="alert-base error-alert mb-4">...</motion.div>} </AnimatePresence>
        <AnimatePresence> {successMessage && <motion.div className="alert-base success-alert mb-4">...</motion.div>} </AnimatePresence>

        {/* Settings Form Card */}
        <form onSubmit={handleSaveSettings} className="bg-white p-6 sm:p-8 rounded-xl shadow-lg border border-gray-200 space-y-8">
          {" "}
          {/* Increased spacing */}
          {/* Step 1: Initial Keywords & Suggestion Button */}
          <div className="space-y-1.5">
            <label htmlFor="initialKeywords" className="block text-sm font-medium text-gray-800">
              Enter 1-3 Initial Keywords or Concepts <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="text"
                id="initialKeywords"
                className="input-style flex-grow"
                placeholder="e.g., social media scheduling, validate startup idea"
                value={initialKeywords}
                onChange={(e) => setInitialKeywords(e.target.value)}
                aria-describedby="initial-keywords-help"
              />
              <button
                type="button" // Prevent form submission
                onClick={handleSuggestKeywords}
                disabled={isSuggesting || !initialKeywords.trim()}
                // Use themed primary style but maybe slightly less prominent than save? Or same style.
                className="inline-flex items-center justify-center bg-emerald-100 text-emerald-700 hover:bg-emerald-200 active:bg-emerald-300 text-sm font-semibold py-2.5 px-5 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
              >
                {isSuggesting ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Lightbulb className="w-5 h-5 mr-2" />}
                {isSuggesting ? "Getting Suggestions..." : "Get AI Suggestions"}
              </button>
            </div>
            <p id="initial-keywords-help" className="text-xs text-gray-500">
              Provide your core topics to get relevant AI keyword suggestions.
            </p>
          </div>
          {/* Step 2: Display Suggestions & Allow Selection */}
          {/* Only show if suggestions are available */}
          <AnimatePresence>
            {suggestedKeywords.length > 0 && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                className="space-y-3 pt-4 border-t border-gray-100 overflow-hidden"
              >
                <label className="block text-sm font-medium text-gray-800">
                  Select Keywords to Track (Select up to {keywordLimit} for your {planName} plan)
                </label>
                <div className="max-h-60 overflow-y-auto custom-scrollbar p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                    {suggestedKeywords.map((keyword) => (
                      <label
                        key={keyword}
                        className={`flex items-center space-x-2 p-2 rounded-md border transition-colors cursor-pointer ${
                          selectedKeywords.includes(keyword)
                            ? "bg-emerald-100 border-emerald-300 ring-1 ring-emerald-400"
                            : "bg-white border-gray-200 hover:bg-gray-100"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 focus:ring-offset-0"
                          checked={selectedKeywords.includes(keyword)}
                          onChange={() => handleKeywordSelection(keyword)}
                          // Disable checkbox if limit reached and this one isn't selected
                          disabled={selectedKeywords.length >= keywordLimit && !selectedKeywords.includes(keyword)}
                        />
                        <span
                          className={`text-xs font-medium truncate ${
                            selectedKeywords.includes(keyword) ? "text-emerald-800" : "text-gray-700"
                          }`}
                        >
                          {keyword}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
                <p className="text-xs text-gray-500">
                  You have selected {selectedKeywords.length} / {keywordLimit} keywords.
                </p>
              </motion.div>
            )}
          </AnimatePresence>
          {/* Step 3: Selected Keywords Summary (Optional display) */}
          {/* Can show the selectedKeywords list here if helpful */}
          {/* Negative Keywords Input Section */}
          <div className="space-y-1.5 pt-4 border-t border-gray-100">
            <label htmlFor="negativeKeywords" className="block text-sm font-medium text-gray-800">
              {" "}
              Negative Keywords (Optional){" "}
            </label>
            <input
              type="text"
              id="negativeKeywords"
              className="input-style"
              placeholder="e.g., free, hiring, job..."
              value={negativeKeywords}
              onChange={(e) => setNegativeKeywords(e.target.value)}
              aria-describedby="negative-keywords-help"
            />
            <p id="negative-keywords-help" className="mt-1.5 text-xs text-gray-500">
              {" "}
              Comma-separated terms to exclude irrelevant results.
            </p>
          </div>
          {/* Is Active Toggle Section */}
          <div className="flex items-center pt-4 border-t border-gray-100">
            <label htmlFor="is_active_toggle" className="flex items-center cursor-pointer group">
              <input
                type="checkbox"
                id="is_active_toggle"
                className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
              <span className="ml-3 text-sm text-gray-800 font-medium group-hover:text-emerald-700 transition-colors">
                {" "}
                Activate AI Lead Scanning
              </span>
            </label>
            <span className="ml-4 text-xs text-gray-400 hidden sm:inline">(Enable this for automated scans)</span>
          </div>
          {/* Info Box */}
          <div className="bg-emerald-50/70 border border-emerald-200/80 rounded-lg p-4 flex items-start space-x-3">
            {" "}
            <Info size={20} className="text-emerald-600 flex-shrink-0 mt-0.5" />{" "}
            <div>
              {" "}
              <h4 className="text-sm font-medium text-emerald-900 mb-1">How Lead Finder Works</h4>{" "}
              <p className="text-xs text-emerald-800">
                {" "}
                Your selected keywords will be used for automated scans if activated. Actions on discovered leads consume Lead Credits.{" "}
              </p>{" "}
            </div>{" "}
          </div>
          {/* Save Button Section */}
          <div className="pt-6 border-t border-gray-200 flex justify-end">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              disabled={isSaving || selectedKeywords.length === 0 || selectedKeywords.length > keywordLimit} // Disable if saving or invalid selection
              className="primary-button-style" // Apply primary style
            >
              {isSaving ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Save className="w-5 h-5 mr-2" />}
              {isSaving ? "Saving..." : "Save Configuration"}
            </motion.button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default LeadFinderSetup;
